/* eslint-disable */
import Vue from 'vue'
import includes from "lodash/includes";
import forEach from "lodash/forEach";
import orderBy from "lodash/orderBy";
import {stateMerge} from "../object-merge";

const getDefaultState = () => {
    return {
        items: {},
    }
};

const state = getDefaultState();

const getters = {
    getById: (state) => {
        return (id) => {
            return state.items[id];
        }
    },
};

const actions = {
    async set({commit, state, dispatch}, items) {
        if (items)
            commit("MERGE_STATE", items)
    },
};

const mutations = {
    MERGE_STATE(state, data) {
        stateMerge(state, data, 'items', false, true)
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
